import { render } from "./OptimizedImage.vue?vue&type=template&id=3646f214&scoped=true&ts=true"
import script from "./OptimizedImage.vue?vue&type=script&lang=ts"
export * from "./OptimizedImage.vue?vue&type=script&lang=ts"

import "./OptimizedImage.vue?vue&type=style&index=0&id=3646f214&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3646f214"]])

export default __exports__